import { format, parse } from '@legacy/js/date/date-fns.js';

export default class BatchTeamMemberRelation {
    constructor() {
        this.action = 'TeamAssignment';
        this.entity = 'ClubMember';
        this.start = null;
        this.end = null;
    }

    serialize() {
        const start = parse(this.start, 'dd.MM.yyyy', new Date());
        const end = this.end === null ? null : parse(this.end, 'dd.MM.yyyy', new Date());
        return {
            action: this.action,
            entity: this.entity,
            ids: this.ids,
            teamId: this.team?.id,
            start: format(start, 'dd.MM.yyyy'),
            end: end === null ? null : format(end, 'dd.MM.yyyy'),
        };
    }

    isValid() {
        if (!this.team) {
            return false;
        }
        if (!this.start) {
            return false;
        }
        if (!this.ids || this.ids.length === 0) {
            return false;
        }
        return true;
    }
}
